import * as React from 'react';

import { useReplyScrollStoreContext } from './replyScrollContext';

/** Лоадер догрузки истории при скролле к реплаю. Чужие подписчики стора не ререндерятся. */
export const useIsReplyScrollLoading = () => {
  const store = useReplyScrollStoreContext();

  const isReplyScrollProcessing = React.useSyncExternalStore(
    store.subscribe,
    store.isReplyScrollProcessing,
    () => false,
  );

  return { isReplyScrollProcessing, cancelHistoryLoading: store.cancelHistoryLoading };
};
